import {
  DOWNLOAD_BATCHES_DATA_REQUEST,
  FETCH_BATCH_METADATA_REQUEST,
  FETCH_BATCHES_REQUEST,
  GET_BATCH_DETAILS,
  GET_PRODUCT_META_LIST,
  GET_SITE_META_LIST,
  GET_MFG_META_LIST,
  All_BATCHES,
  GET_ALL_BATCHES,
  GET_BATCHES_STATUS,
  GET_BATCHES_TO_DOWNLOAD
} from "./types";
import { initialState } from "./initialState";
import { errorMessage } from "../../constants/responseMessages";
import batchesService from "../../services/batchesService";
import { data } from "./dummyData";
// import * as types from "./types";

// const service = new BatchesService();

export const fetchBatches = (requestData) => async (dispatch) => {
  dispatch({
    type: FETCH_BATCHES_REQUEST,
    payload: { ...initialState?.apiStatus, loader: true },
  });
  try {
    const response = await batchesService.getBatchData(requestData);
    dispatch({
      type: FETCH_BATCHES_REQUEST,
      payload: {
        ...initialState?.apiStatus,
        loader: false,
        data: response?.data?.data,
      },
    });
  } catch (error) {
    dispatch({
      type: FETCH_BATCHES_REQUEST,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        message: errorMessage(error),
        apiError: true,
      },
    });
    // dispatch({
    //   type: FETCH_BATCHES_REQUEST,
    //   payload: {
    //     ...initialState?.apiStatus,
    //     loader: false,
    //     data: data,
    //   },
    // });
  }
};

export const fetchBatchMetaData = (requestData) => async (dispatch) => {
  dispatch({
    type: FETCH_BATCH_METADATA_REQUEST,
    payload: { ...initialState?.apiStatus, loader: true },
  });
  try {
    const response = await batchesService.fetchBatchMetaData(requestData);
    dispatch({
      type: FETCH_BATCH_METADATA_REQUEST,
      payload: {
        ...initialState?.apiStatus,
        loader: false,
        data: { data: response?.data?.data, batchId: requestData?.batch_id },
      },
    });
  } catch (error) {
    dispatch({
      type: FETCH_BATCH_METADATA_REQUEST,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        message: errorMessage(error),
        apiError: true,
      },
    });
  }
};

export const resetDownloadBatchesData = () => (dispatch) => {
  dispatch({
    type: DOWNLOAD_BATCHES_DATA_REQUEST,
    payload: { ...initialState?.apiStatus },
  });
}

export const downloadBatchesData = (requestData) => async (dispatch) => {
  dispatch({
    type: DOWNLOAD_BATCHES_DATA_REQUEST,
    payload: { ...initialState?.apiStatus, loader: true, success: false },
  });

  try {
    const response = await batchesService.downloadBatchesData(requestData);

    dispatch({
      type: DOWNLOAD_BATCHES_DATA_REQUEST,
      payload: {
        ...initialState?.apiStatus,
        loader: false,
        success: true,
        data: response?.data, // <-- should be PDF binary
        file_name: response?.file_name,
      },
    });
  } catch (error) {
    setTimeout(() => {
      dispatch({
        type: DOWNLOAD_BATCHES_DATA_REQUEST,
        payload: {
          ...initialState.apiStatus,
          loader: false,
          success: false,
          message: errorMessage(error),
          apiError: true,
        },
      });
    }, 5000);
  }
};


export const getBatchDetails = (data) => {
  return (dispatch) => {
    dispatch({
      type: GET_BATCH_DETAILS,
      payload: { ...initialState, loader: true },
    });
    batchesService
      .getBatchDetails(data)
      .then((res) => {
        dispatch({
          type: GET_BATCH_DETAILS,
          payload: { data: res.data, loader: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_BATCH_DETAILS,
          payload: {
            ...initialState,
            // data: DummyData, //todo remove this after api integration
            msg: error.message || "Error fetching limit dropdown",
            loader: false,
            next: false,
          },
        });
      });
  };
};


export const getProductMetaList = (data) => {
  return (dispatch) => {
    dispatch({
      type: GET_PRODUCT_META_LIST,
      payload: { ...initialState, loading: true },
    });
    batchesService
      .getProductMetaList(data)
      .then((res) => {
        dispatch({
          type: GET_PRODUCT_META_LIST,
          payload: { data: res.data, loading: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_PRODUCT_META_LIST,
          payload: {
            ...initialState,
            msg: error.message || "Error fetching limit dropdown",
            loading: false,
            next: false,
          },
        });
      });
  };
};

export const getSiteMetaList = (data) => {
  return (dispatch) => {
    dispatch({
      type: GET_SITE_META_LIST,
      payload: { ...initialState, loading: true },
    });
    batchesService
      .getSiteMetaList(data)
      .then((res) => {
        dispatch({
          type: GET_SITE_META_LIST,
          payload: { data: res.data, loading: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_SITE_META_LIST,
          payload: {
            ...initialState,
            msg: error.message || "Error fetching limit dropdown",
            loading: false,
            next: false,
          },
        });
      });
  };
};


export const getUnitOperationMetaList = (data) => {
  return (dispatch) => {
    dispatch({
      type: GET_MFG_META_LIST,
      payload: { ...initialState, loading: true },
    });
    batchesService.getUnitOperationMetaList(data)
      .then((res) => {
        dispatch({
          type: GET_MFG_META_LIST,
          payload: { data: res.data, loading: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_MFG_META_LIST,
          payload: {
            ...initialState,
            msg: error.message || "Error fetching limit dropdown",
            loading: false,
            next: false,
          },
        });
      });
  };
};


export const expoortBatches = (data, obj) => {
  return (dispatch) => {
    dispatch({
      type: All_BATCHES,
      payload: { ...initialState, loading: true },
    });
    return batchesService
      .exportAllBatches(data, obj)
      .then((res) => {
        dispatch({
          type: All_BATCHES,
          payload: {
            data: res.data.data,
            message: res.data.message,
            status: 200,
            loading: false,
          },
        });
        return res;
      })
      .catch((error) => {
        dispatch({
          type: All_BATCHES,
          payload: {
            ...initialState,
            message: error.message || "Error fetching data",
            loading: false,
            status: error.response?.status || 500,
          },
        });
        throw error
      });
  };
};

export const getBatchesIds = (data) => {
  return (dispatch) => {
    dispatch({
      type: GET_ALL_BATCHES,
      payload: { ...initialState, loading: true },
    });
    return batchesService
      .getAllBatches(data)
      .then((res) => {
        dispatch({
          type: GET_ALL_BATCHES,
          payload: {
            data: res.data.data,
            message: res.data.message,
            status: 200,
            loading: false,
          },
        });
        return res;
      })
      .catch((error) => {
        dispatch({
          type: GET_ALL_BATCHES,
          payload: {
            ...initialState,
            message: error.message || "Error fetching data",
            loading: false,
            status: error.response?.status || 500,
          },
        });
        throw error
      });
  };
};


export const getBatchesStatus = (data) => {
  return (dispatch) => {
    dispatch({
      type: GET_BATCHES_STATUS,
      payload: { ...initialState, loading: true },
    });
    return batchesService
      .getAllBatcheStatus(data)
      .then((res) => {
        dispatch({
          type: GET_BATCHES_STATUS,
          payload: {
            data: res.data.data,
            message: res.data.message,
            status: 200,
            loading: false,
          },
        });
        return res;
      })
      .catch((error) => {
        dispatch({
          type: GET_BATCHES_STATUS,
          payload: {
            ...initialState,
            message: error.message || "Error fetching data",
            loading: false,
            status: error.response?.status || 500,
          },
        });
        throw error
      });
  };
};
